module.exports = __webpack_public_path__ + "img/hotel_room.f99f9ecd.png";